import { FC } from "react";
import { Trans } from "@lingui/macro";
import {
  connectCurrentRefinements,
  connectStats,
} from "react-instantsearch-dom";
import { Button } from "src/atoms/Button";
import {
  CurrentRefinementsProvided,
  SearchState,
  StatsProvided,
} from "react-instantsearch-core";
import { ButtonsContainer } from "./ClearAllRefinements.styled";
import {
  PROMOTION_FACET,
  GENDERS_FACET,
  CATEGORIES_SLUG_FACET,
  BRAND_DEPARTMENTS_FACET,
  CATEGORIES_FACET,
} from "src/utils/algolia";
import { filterFacets } from "src/organisms/AlgoliaProductList/utils/filterFacets";
import { Box } from "@otrium/core";

interface StatsPops extends StatsProvided {
  handleClose: () => void;
}

const Stats: FC<StatsPops> = ({ handleClose, nbHits }) => {
  const total = nbHits;

  return (
    <Button
      data-testid="close-filters"
      variant="primary"
      onClick={handleClose}
      fullWidth
    >
      <Trans>Show {total} results</Trans>
    </Button>
  );
};

const CustomStats = connectStats(Stats);

interface CustomRefinementsProps extends CurrentRefinementsProvided {
  handleClose: () => void;
  onResetFilters: () => void;
  excludedFiltersList?: string[];
  keepSelectedIgnoreInActive?: { [p: string]: string[] };
  setStatePayload?: (
    payload: SearchState & { selectedCatSlug: string[] }
  ) => void;
  selectedCatSlug?: string[];
}

const CustomRefinements: FC<CustomRefinementsProps> = ({
  handleClose,
  onResetFilters,
  items,
  excludedFiltersList = [],
  keepSelectedIgnoreInActive,
  setStatePayload,
  selectedCatSlug,
}) => {
  const filtersToExclude = excludedFiltersList.concat([
    GENDERS_FACET,
    PROMOTION_FACET,
    CATEGORIES_SLUG_FACET,
    BRAND_DEPARTMENTS_FACET,
  ]);
  const facetsToRefine = items.filter((item) => {
    return (
      !filtersToExclude.includes(item.attribute) &&
      filterFacets(item, keepSelectedIgnoreInActive, selectedCatSlug)
    );
  });

  const refineFacets = () => {
    if (setStatePayload) {
      const toRefine = facetsToRefine.reduce((a, b) => {
        a[b.attribute] = "";
        return a;
      }, {} as { [p: string]: string });
      setStatePayload({
        refinementList: { ...toRefine, [CATEGORIES_FACET]: [] },
        selectedCatSlug: [],
        range: undefined,
        menu: undefined,
      });
    }
  };

  return (
    <ButtonsContainer>
      {facetsToRefine.length ? (
        <>
          <Box mb={2} width="100%">
            <Button
              data-testid="reset-filters"
              variant="tertiary"
              onClick={() => {
                refineFacets();
                onResetFilters();
              }}
              fullWidth
            >
              <Trans>Reset all filters</Trans>
            </Button>
          </Box>

          <CustomStats handleClose={handleClose} />
        </>
      ) : (
        <Button
          variant="primary"
          onClick={handleClose}
          fullWidth
          css={{
            ":hover": {
              boxShadow: "none",
              backgroundColor: "Black",
            },
          }}
        >
          <Trans>Close</Trans>
        </Button>
      )}
    </ButtonsContainer>
  );
};

const ClearAllRefinements = connectCurrentRefinements(CustomRefinements);

export default ClearAllRefinements;
